import { render, staticRenderFns } from "./addNewTasks.vue?vue&type=template&id=3b064ba2&scoped=true&"
import script from "./addNewTasks.vue?vue&type=script&lang=js&"
export * from "./addNewTasks.vue?vue&type=script&lang=js&"
import style0 from "./addNewTasks.vue?vue&type=style&index=0&id=3b064ba2&prod&scoped=true&lang=less&"
import style1 from "./addNewTasks.vue?vue&type=style&index=1&id=3b064ba2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b064ba2",
  null
  
)

export default component.exports